/**
 * DecisionZones — chart plugin that renders AI-generated price bands
 * (potential_long/short, sweep, support, resistance, breakout,
 * pullback, trend_continuation). Requests `priceLine` capabilities
 * for each zone's upper and lower bounds so the provider-agnostic
 * abstraction stays intact.
 */
const KIND_META = {
  potential_long:      { color: '#00ff88', label: 'LONG' },
  potential_short:     { color: '#ff3366', label: 'SHORT' },
  liquidity_sweep:     { color: '#f7c948', label: 'SWEEP' },
  support:             { color: '#00e5ff', label: 'S' },
  resistance:          { color: '#ff7ac6', label: 'R' },
  breakout:            { color: '#a78bfa', label: 'BREAKOUT' },
  trend_continuation:  { color: '#60a5fa', label: 'TREND' },
  pullback:            { color: '#94a3b8', label: 'PULLBACK' },
};

export function makeDecisionZonesPlugin(zones = []) {
  return {
    name: 'decision_zones',
    _handles: [],
    _engine: null,
    attach(engine) {
      this._engine = engine;
      for (const z of zones) {
        const meta = KIND_META[z.kind] || { color: '#94a3b8', label: z.kind };
        // Two horizontal lines (upper + lower) per zone.
        for (const price of [z.from_price, z.to_price]) {
          if (price == null || isNaN(price)) continue;
          const h = engine.capability('priceLine', {
            price,
            color: meta.color,
            title: `${meta.label} · $${Number(price).toFixed(4)}`,
          });
          if (h) this._handles.push(h);
        }
      }
    },
    onData() { /* zones are static per analysis run */ },
    onUpdate() {},
    detach() {
      for (const h of this._handles) this._engine?.releaseCapability(h);
      this._handles = [];
      this._engine = null;
    },
  };
}
